import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import './AppLayout.css';

export default function AppLayout() {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user) return null;

  return (
    <div className="app-layout">
      <header className="app-header">
        <div className="app-header__left">
          <button
            className="app-header__hamburger"
            onClick={() => setSidebarOpen((prev) => !prev)}
            aria-label="Abrir menu de navegação"
            aria-expanded={sidebarOpen}
          >
            ☰
          </button>
          <span className="app-header__brand">Vavassori Designer</span>
        </div>
        <div className="app-header__right">
          <span className="app-header__user-name">{user.nome}</span>
          <button className="app-header__logout" onClick={logout}>
            Sair
          </button>
        </div>
      </header>

      <div className="app-layout__body">
        <Sidebar
          userType={user.tipo}
          temSenhaLocal={user.temSenhaLocal}
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        <main className="app-layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
